import Vue from 'vue';
import Router from 'vue-router';
import Error from '@/components/404/404';
import Dash from '@/components/dashboard/dashboard';
import Dash_Page from '@/components/dashboard/dash_page/dash_page';
import Dash_Modules from '@/components/dashboard/dash_modules/dash_modules';
import Slider from '@/components/slider/slider';
import Module_1 from '@/components/module_1/module_1';
import Module_2 from '@/components/module_2/module_2';
import Module_3 from '@/components/module_3/module_3'
import Module_4 from '@/components/module_4/module_4';
import Module_5 from '@/components/module_5/module_5';
import Module_6 from '@/components/module_6/module_6'

Vue.use(Router);

export default new Router({
    mode: 'history',
    scrollBehavior(to, from, savedPosition) {
        if (to.hash) {
            return {
                selector: to.hash
            }
        }
    },
    routes: [
        {
            path: '*',
            name: '404',
            component: Error
        },
        {
            path: '/',
            component: Dash,
            children: [
                {
                    path: '',
                    component: Dash_Modules
                },
                {
                    path: 'resources',
                    component: Dash_Page,
                    props: {
                        page: 'resources'
                    }
                },
                {
                    path: 'orgs',
                    component: Dash_Page,
                    props: {
                        page: 'orgs'
                    }

                },
                {
                    path: 'credits',
                    component: Dash_Page,
                    props: {
                        page: 'credits'
                    }
                },
            ]
        },
        {
            path: '/module-1',
            name: 'module_1',
            component: Module_1
        },
        {
            path: '/module-2',
            name: 'module_2',
            component: Module_2
        },
        {
            path: '/module-3',
            name: 'module_3',
            component: Module_3
        },
        {
            path: '/module-4',
            name: 'module_4',
            component: Module_4
        },
        {
            path: '/module-5',
            name: 'module_5',
            component: Module_5
        },
        {
            path: '/module-6',
            name: 'module_6',
            component: Module_6
        },
        {
            path: '/slider/:module_number',
            name: 'slider',
            component: Slider
        }
    ]
});



// WEBPACK FOOTER //
// ./src/router/index.js